module.exports = __webpack_public_path__ + "static/media/file-htm.a521164c.svg";